export const statusMap = {
  started: "Processing Frames",
  completed: "Stitching videos together",
  uploaded: "Generated",
  generated: "Starting...",
};
